module.exports = __webpack_public_path__ + "static/media/1717128339495-min.d713c2c7.JPG";